export enum AudioState {
  Initial,
  Playing,
  Pausing
}
